<template>
  <div class="pt-4">
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      :property-mapping="errorPropertyMappings"
    />
    <u-loader v-if="isLoading" />
    <template v-else>
      <div class="card shadow mb-4 p-2">
        <div
          v-if="
            listItems.filter((item) => {
              return item.ruleGroupId == null;
            }).length > 0
          "
          class="w-100"
        >
          <rule-edit
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :rule-id="-1"
            :version-id="versionId"
            :highest-order="highestUngroupedOrder"
            class="float-right"
            @ruleSaved="handleListItemSaved()"
          />

          <button
            v-if="
              listItemsHistory.checkChangesHistory() &&
                (listItemsHistory.checkChangesForLinks()
                  ? groupedItemsHistory.checkChangesForLinks()
                  : true)
            "
            v-b-tooltip.hover
            class="btn btn-primary mr-1 float-right"
            placement="bottom"
            title="Änderungen Rückgängig machen"
            type="button"
            @click="undoListItems(true)"
          >
            <i class="fas fa-undo" />
          </button>

          <button
            v-if="selectedUngrouped.length > 0 && canUserEdit"
            v-b-tooltip.hover
            class="btn btn-primary mr-1 float-right"
            placement="bottom"
            title="Auswahl umkehren"
            type="button"
            @click="switchSelection"
          >
            <i class="fas fa-exchange-alt" />
          </button>

          <button
            v-b-tooltip.hover
            :title="
              !ungroupedMinimized
                ? 'Ungruppierte Regeln minimieren'
                : 'Ungruppierte Regeln maximieren'
            "
            class="btn btn-secondary mr-1 float-right"
            placement="bottom"
            type="button"
            @click="ungroupedMinimized = !ungroupedMinimized"
          >
            <i
              v-if="!ungroupedMinimized"
              class="fas fa-minus"
            />
            <i
              v-else
              class="fas fa-plus"
            />
          </button>

          <rule-bulk-edit
            v-if="selectedUngrouped.length > 0"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :selected-rules="selectedUngrouped"
            :version-id="versionId"
            class="float-right"
            unique-identifier="topUngrouped"
            @ruleSaved="handleListItemSaved()"
          />

          <rule-bulk-copy-move
            v-if="selectedUngrouped.length > 0"
            :all-groups="ruleGroups"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :selected-rules="selectedUngrouped"
            :version-id="versionId"
            class="float-right"
            unique-identifier="topUngrouped"
            @ruleSaved="$emit('updated')"
          />

          <rule-bulk-delete
            v-if="selectedUngrouped.length > 0"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :selected-rules="selectedUngrouped"
            :version-id="versionId"
            class="float-right"
            unique-identifier="deletebottomUngrouped"
            @ruleSaved="handleListItemSaved()"
          />
        </div>
        <h4 class="ml-2 mb-3">
          Ungruppierte Regeln
        </h4>
        <div
          v-if="
            listItems.filter((item) => {
              return item.ruleGroupId == null;
            }).length > 0
          "
          v-show="ungroupedMinimized"
          class="ml-4 m-2"
        >
          Ungruppierte Regeln sind ausgeblendet.
        </div>
        <v-data-table
          v-if="
            listItems.filter((item) => {
              return item.ruleGroupId == null;
            }).length > 0
          "
          v-show="!ungroupedMinimized"
          v-model="selectedUngrouped"
          :headers="tableHeaders"
          :items="
            listItems.filter((item) => {
              return item.ruleGroupId == null;
            })
          "
          :pagination.sync="pagination[0]"
          :rows-per-page-items="rowsPerPage"
          class="mb-4 specialHeight"
          disable-initial-sort
          hide-actions
          select-all
          @update:pagination="
            $emit('togglePagination', {
              pagination: $event,
              ruleGroupId: 0,
            })
          "
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox
                v-model="props.selected"
                hide-details
                primary
              />
            </td>
            <td
              v-for="(header, index) in tableHeaders"
              :key="index"
            >
              <div v-if="index == tableHeaders.length - 1">
                <div class="d-flex">
                  <rule-edit
                    :configuration="configuration"
                    :contract-id="contractId"
                    :edition-id="editionId"
                    :rule-id="props.item.id"
                    :version-id="versionId"
                    :highest-order="highestUngroupedOrder"
                    @ruleSaved="handleListItemSaved()"
                  />

                  <button
                    v-if="canUserEdit"
                    v-b-modal.deleteRule
                    v-b-tooltip.hover
                    class="btn btn-danger smallActionButton float-right ml-1"
                    placement="bottom"
                    title="Regel löschen"
                    type="button"
                    @click="ruleToDelete = props.item.id"
                  >
                    <i class="fas fa-trash-alt" />
                  </button>
                </div>
              </div>
              <div
                v-else
                class="cursorpointer noselect"
                @dblclick="selectProperty(props.item, header)"
              >
                {{ props.item[header.value] | ruleValueDisplay }}
              </div>
            </td>
          </template>
        </v-data-table>
        <div
          v-else
          class="ml-2 mt-2 small"
        >
          Keine Regeln definiert
        </div>
        <div class="w-100">
          <rule-edit
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :rule-id="0"
            :version-id="versionId"
            :highest-order="highestUngroupedOrder"
            class="float-right"
            name="ValueSetUngroupBottom"
            @ruleSaved="handleListItemSaved()"
          />
          <button
            v-if="
              listItemsHistory.checkChangesHistory() &&
                (listItemsHistory.checkChangesForLinks()
                  ? groupedItemsHistory.checkChangesForLinks()
                  : true)
            "
            v-b-tooltip.hover
            class="btn btn-primary mr-1 float-right"
            placement="bottom"
            title="Änderungen Rückgängig machen bottom"
            type="button"
            @click="undoListItems(true)"
          >
            <i class="fas fa-undo" />
          </button>
          <button
            v-if="selectedUngrouped.length > 0"
            v-b-tooltip.hover
            class="btn btn-primary mr-1 float-right"
            placement="bottom"
            title="Auswahl umkehren"
            type="button"
            @click="switchSelection"
          >
            <i class="fas fa-exchange-alt" />
          </button>

          <rule-bulk-edit
            v-if="selectedUngrouped.length > 0"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :selected-rules="selectedUngrouped"
            :version-id="versionId"
            class="float-right"
            unique-identifier="bottomUngrouped"
            @ruleSaved="handleListItemSaved()"
          />

          <rule-bulk-delete
            v-if="selectedUngrouped.length > 0"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :selected-rules="selectedUngrouped"
            :version-id="versionId"
            class="float-right"
            unique-identifier="deletebottomUngrouped"
            @ruleSaved="handleListItemSaved()"
          />
        </div>
      </div>
      <div class="card p-2 shadow">
        <div class="w-100">
          <button
            v-if="canUserEdit"
            v-b-modal.addNewGroupedRule
            v-b-tooltip.hover
            class="btn btn-success float-right"
            placement="bottom"
            title="Neue Gruppierung hinzufügen"
            type="button"
          >
            <i class="fas fa-plus" />
          </button>
          <button
            v-if="
              groupedItemsHistory.checkChangesHistory() &&
                (groupedItemsHistory.checkChangesForLinks()
                  ? listItemsHistory.checkChangesForLinks()
                  : true)
            "
            v-b-tooltip.hover
            class="btn btn-primary mr-1 float-right"
            placement="bottom"
            title="Änderungen Rückgängig machen"
            type="button"
            @click="undoGroupItems(true)"
          >
            <i class="fas fa-undo" />
          </button>
        </div>
        <h4 class="mb-3 ml-2">
          Gruppierte Regeln
        </h4>
        <div
          v-if="ruleGroups.length == 0"
          class="my-4 ml-2 small"
        >
          Keine Gruppierungen definiert
        </div>
        <div
          v-for="(ruleGroup, ruleGroupIndex) in ruleGroups"
          :key="ruleGroupIndex"
          class=""
        >
          <rule-groups
            :all-groups="ruleGroups"
            :configuration="configuration"
            :contract-id="contractId"
            :edition-id="editionId"
            :rule-group="ruleGroup"
            :version-id="versionId"
            :expanded-groups="expandedRuleGroups"
            :pagination="
              pagination[ruleGroup.id] ? pagination[ruleGroup.id] : {}
            "
            @collectionChanged="handleRuleGroupSaved"
            @toggleExpanded="$emit('toggleExpandedRuleGroups', $event)"
            @togglePagination="
              $emit('togglePagination', {
                pagination: $event,
                ruleGroupId: ruleGroup.id,
              })
            "
          />
        </div>
      </div>
    </template>
    <b-modal
      id="deleteRule"
      ref="deleteRule"
      class="mt-4"
      hide-footer
      no-fade
      title="Regel Löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass sie diese Regel löschen möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteRule()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('deleteRule')"
      >
        Abbrechen
      </b-button>
    </b-modal>

    <b-modal
      id="deleteGroupedRule"
      ref="deleteGroupedRule"
      class="mt-4"
      hide-footer
      no-fade
      title="Gruppe erstellen"
    >
      <div class="d-block mb-4">
        <u-error-handling
          v-if="deleteGroupedRuleError"
          :error-object="deleteGroupedRuleError"
        />
        Sind Sie sicher, dass sie eine neue Gruppe erstellen möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteGroupedRule"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('addNewGroupedRule')"
      >
        Abbrechen
      </b-button>
    </b-modal>
    <b-modal
      id="addNewGroupedRule"
      ref="addNewGroupedRule"
      class="mt-4"
      hide-footer
      no-fade
      title="Gruppe erstellen"
    >
      <div class="d-block mb-4">
        <u-error-handling
          v-if="newGroupedRuleError"
          :error-object="newGroupedRuleError"
        />
        Sind Sie sicher, dass sie eine neue Gruppe erstellen möchten?
      </div>
      <b-button
        variant="success"
        @click="addNewGroupedRule"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('addNewGroupedRule')"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  GetRuleValues,
  DeleteRule,
  AddGroupedRule,
  DeleteGroupedRule,
  AddRule,
  AddBulkRules,
  SaveRule,
  SaveBulkRule,
  SaveGroupedRuleConfiguration,
} from "@/services/minimum.wage.services/rules.minimum.wages.js";
import RuleGroups from "@/components/minimum.wage/pages/Rules/RuleGroups.vue";
import RuleEdit from "@/components/minimum.wage/pages/Rules/RuleEdit.vue";
import RuleBulkEdit from "@/components/minimum.wage/pages/Rules/RuleBulkEdit.vue";
import RuleBulkDelete from "@/components/minimum.wage/pages/Rules/RuleBulkDelete.vue";
import RuleBulkCopyMove from "./RuleBulkCopyMove.vue";
import { GetPossibleStructureValues } from "@/services/minimum.wage.services/criteria.minimum.wages.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  components: {
    RuleGroups,
    RuleEdit,
    RuleBulkEdit,
    RuleBulkDelete,
    RuleBulkCopyMove,
  },
  mixins: [MinimumWageMixin],
  props: {
    rules: {
      type: Array,
      required: true,
    },
    configuration: {
      type: Object,
      required: true,
    },
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
    expandedRuleGroups: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      errorObject: null,
      errorPropertyMappings: null,
      newRuleErrorObject: null,
      newGroupedRuleError: null,
      deleteErrorObject: null,
      deleteGroupedRuleError: null,
      tableHeaders: [],
      ruleGroups: [],
      rowsPerPage: [{ text: "Alle", value: -1 }, 10, 25, 50, 100],
      listItems: [],
      isVisible: false,
      ruleToEdit: null,
      selectedUngrouped: [],
      ungroupedMinimized: false,
      criteriaStructureOptions: new Map(),
      listItemsHistory:
        this.$store.state.history.mindestLohnKonfiguration.ruleConfiguration
          .ungroupedRuleConfig,
      groupedItemsHistory:
        this.$store.state.history.mindestLohnKonfiguration.ruleConfiguration
          .groupedRulesConfig,
    };
  },
  computed: {
    highestUngroupedOrder() {
      if (this.listItems && this.listItems.length > 0) {
        return Math.max(
          ...this.listItems
            .filter((item) => item.ruleGroupId == null)
            .map((item) => item.order),
        );
      }
      return 0;
    },
  },
  created() {
    this.loadAllRules();
    // eslint-disable-next-line
    if (
      this.listItemsHistory &&
      this.listItemsHistory.getChangesHistory().length === 0
    ) {
      this.$store.state.history.shouldUpdateListitemHistory = true;
      this.GetAllValuesForRule(true);
    }
    // eslint-disable-next-line
    if (
      this.groupedItemsHistory &&
      this.groupedItemsHistory.getChangesHistory().length === 0
    ) {
      this.$store.state.history.shouldUpdateGroupHistory = true;
      this.GetAllValuesForRule(true);
    }
  },
  methods: {
    initialLoadingDone() {
      let numberOfCriteriaStructureConfigEntries =
        this.configuration.configEntries.filter(
          (x) => x.criteriaStructureId,
        ).length;
      if (
        this.isLoading == false &&
        this.criteriaStructureOptions.size ==
          numberOfCriteriaStructureConfigEntries &&
        this.tableHeaders.length > 0
      ) {
        return true;
      }
      return false;
    },
    handleListItemSaved() {
      this.$store.state.history.shouldUpdateListitemHistory = true;
      this.$emit("updated");
    },
    handleRuleGroupSaved() {
      this.$store.state.history.shouldUpdateGroupHistory = true;
      this.$emit("updated");
    },
    updateUndoHistory() {
      if (
        !this.$store.state.history.shouldUpdateListitemHistory &&
        !this.$store.state.history.shouldUpdateGroupHistory
      ) {
        return;
      }
      //check which links need to be added
      let listItemsLinks = [];
      let groupedItemsLinks = [];
      if (
        this.$store.state.history.shouldUpdateGroupHistory &&
        this.$store.state.history.shouldUpdateListitemHistory
      ) {
        groupedItemsLinks.push(this.listItemsHistory);
        listItemsLinks.push(this.groupedItemsHistory);
      }

      if (this.$store.state.history.shouldUpdateListitemHistory) {
        //Add ListItems changes to history
        if (this.listItems && this.listItems.length > 0) {
          this.listItemsHistory.addChange(this.listItems, listItemsLinks);
        } else {
          this.listItemsHistory.addChange([]);
        }

        this.$store.state.history.shouldUpdateListitemHistory = false;
      }

      if (this.$store.state.history.shouldUpdateGroupHistory) {
        //Add GroupItem changes to history

        this.ruleGroups.forEach((group) => {
          group.groupEntries = [];
        });

        this.listItems.map((item) => {
          if (item.ruleGroupId) {
            let group = this.ruleGroups.filter(
              (x) => x.id === item.ruleGroupId,
            )[0];
            if (group && group.groupEntries) {
              group.groupEntries.push(item);
            }
          }
        });

        if (this.ruleGroups && this.ruleGroups.length) {
          let groups = [];
          this.ruleGroups.forEach((x) => groups.push(x));
          groups = JSON.parse(JSON.stringify(groups));
          this.groupedItemsHistory.addChange(groups, groupedItemsLinks);
        } else {
          this.groupedItemsHistory.addChange([]);
        }

        this.$store.state.history.shouldUpdateGroupHistory = false;
      }
    },
    undoListItems(checkLinks) {
      if (this.listItemsHistory.checkChangesHistory()) {
        const undoFull = this.listItemsHistory.undo();

        this.isLoading = true;
        let diff = [];
        let newValue = undoFull.newValue.value.filter(
          (rule) => !rule.ruleGroupId,
        );
        let oldValue = undoFull.oldValue.value.filter(
          (rule) => !rule.ruleGroupId,
        );

        let undoPromise = new Promise((resolve) => {
          let innerPromises = [];
          if (newValue.length > oldValue.length) {
            diff = newValue.filter(
              (x) => !oldValue.some((y) => this.compareRule(x, y)),
            );

            // When Rules are Restored, they may have different ID from before
            // Need to Adjust Ids in History to match new ID
            diff.forEach((rule) => {
              innerPromises.push(
                new Promise((innerResolve) => {
                  let oldRuleId = rule.id;
                  this.addNewRule(
                    this.transformDisplayedRuleToDTO(rule),
                    (restoredRule) => {
                      this.updateListItemsWithRestore(
                        oldRuleId,
                        restoredRule.id,
                      );
                      innerResolve();
                    },
                  );
                }),
              );
            });
          } else if (newValue.length === oldValue.length) {
            diff = newValue.filter(
              (x) => !oldValue.some((y) => this.compareRule(x, y)),
            );
            innerPromises.push(
              new Promise((innerResolve, innerReject) => {
                diff.forEach((rule) => {
                  this.updateRule(
                    this.transformDisplayedRuleToDTO(rule),
                    () => {
                      innerResolve();
                    },
                    () => {
                      innerReject();
                    },
                  );
                });
              }),
            );
          } else {
            diff = oldValue.filter(
              (x) => !newValue.some((y) => this.compareRule(x, y)),
            );
            innerPromises.push(
              new Promise((innerResolve) => {
                diff.forEach((rule) => {
                  this.ruleToDelete = rule.id;
                  this.deleteRule(() => {
                    innerResolve();
                  }, false);
                });
              }),
            );
          }

          Promise.all(innerPromises).then(() => {
            this.isLoading = false;
            resolve();
          });
        });

        undoPromise.then(() => {
          if (
            checkLinks &&
            checkLinks == true &&
            undoFull.oldValue.links.some((x) => x === this.groupedItemsHistory)
          ) {
            this.undoGroupItems(false);
          }
        });
      }
    },
    undoGroupItems(checkLinks) {
      if (this.groupedItemsHistory.checkChangesHistory()) {
        const undoFull = this.groupedItemsHistory.undo();

        this.isLoading = true;
        let diff = [];
        let newValue = undoFull.newValue.value;
        let oldValue = undoFull.oldValue.value;

        let undoPromise = new Promise((resolve) => {
          let innerPromises = [];
          if (newValue.length > oldValue.length) {
            diff = newValue.filter(
              (x) => !oldValue.some((y) => this.compareRuleGroup(x, y, true)),
            );
            diff.forEach((element) => {
              let oldId = element.id;
              innerPromises.push(
                new Promise((innerResolve) => {
                  this.addNewGroupedRuleEntries(element, (restoredGroup) => {
                    this.updateGroupsWithRestore(oldId, restoredGroup.id);
                    innerResolve();
                  });
                }),
              );
            });
          } else if (newValue.length === oldValue.length) {
            diff = newValue.filter(
              (x) => !oldValue.some((y) => this.compareRuleGroup(x, y, true)),
            );
            diff.forEach((group) => {
              let oldGroup = oldValue.filter((x) => x.id === group.id);
              this.undoChangesToRuleGroup(oldGroup[0], group);
            });
          } else {
            diff = oldValue.filter(
              (x) => !newValue.some((y) => this.compareRuleGroup(x, y, true)),
            );
            diff.forEach((element) => {
              innerPromises.push(
                new Promise((innerResolve) => {
                  if (
                    newValue.length === 0 ||
                    !newValue.some((x) => x.id === element.id)
                  ) {
                    this.groupedRuleToDeleteId = element.id;

                    this.deleteGroupedRule(() => innerResolve());
                  } else {
                    let newGroup = newValue.filter((x) =>
                      diff.some((y) => y.id === x.id),
                    )[0];
                    this.undoChangesToRuleGroup(element, newGroup);
                  }
                }),
              );
            });
          }

          Promise.all(innerPromises).then(() => {
            resolve();
          });
        });

        undoPromise.then(() => {
          if (
            checkLinks &&
            checkLinks == true &&
            undoFull.oldValue.links.some((x) => x === this.listItemsHistory)
          ) {
            this.undoListItems(false);
          } else {
            this.isLoading = false;
          }
        });
      }
    },
    compareRule(firstRule, secondRule) {
      let result = firstRule.id === secondRule.id;
      if (!result) {
        return result;
      }
      Object.keys(firstRule).forEach((key) => {
        result = result ? secondRule.hasOwnProperty(key) : result;
        result = result ? firstRule[key] === secondRule[key] : result;
      });
      Object.keys(secondRule).forEach((key) => {
        result = result ? firstRule.hasOwnProperty(key) : result;
        result = result ? firstRule[key] === secondRule[key] : result;
      });
      return result;
    },
    compareRuleGroup(firstGroup, secondGroup, evaluateChildren) {
      let result = firstGroup.id === secondGroup.id;
      result = result ? firstGroup.name === secondGroup.name : false;
      result = result
        ? firstGroup.ruleConfigurationId === secondGroup.ruleConfigurationId
        : false;
      result = result
        ? firstGroup.groupEntries.length === secondGroup.groupEntries.length
        : false;
      if (result && evaluateChildren) {
        firstGroup.groupEntries.forEach((x) => {
          result = result
            ? secondGroup.groupEntries.some((y) => this.compareRule(x, y))
            : result;
        });
        secondGroup.groupEntries.forEach((x) => {
          result = result
            ? firstGroup.groupEntries.some((y) => this.compareRule(x, y))
            : result;
        });
      }
      return result;
    },
    undoChangesToRuleGroup(oldGroup, newGroup) {
      if (!this.compareRuleGroup(oldGroup, newGroup, false)) {
        this.updateGroupedRule(newGroup);
      }
      let rules = [];
      newGroup.groupEntries.forEach((groupedRule) => {
        let newGroupedRule = this.transformDisplayedRuleToDTO(groupedRule);
        rules.push(newGroupedRule);
      });

      if (oldGroup.groupEntries.length > newGroup.groupEntries.length) {
        oldGroup.groupEntries.forEach((rule) => {
          if (
            oldGroup.groupEntries.some((x) => x.id === rule.id) &&
            !newGroup.groupEntries.some((x) => x.id === rule.id)
          ) {
            this.ruleToDelete = rule.id;
            this.deleteRule(false);
          }
        });
      } else {
        let rulesToUpdate = [];
        let rulesToAdd = [];
        rules.forEach((rule) => {
          if (
            oldGroup.groupEntries.some((x) => x.id === rule.id) &&
            newGroup.groupEntries.some((x) => x.id === rule.id)
          ) {
            let oldRule = oldGroup.groupEntries.find((x) => x.id === rule.id);
            let newRule = newGroup.groupEntries.find((x) => x.id === rule.id);
            if (!this.compareRule(oldRule, newRule)) {
              rulesToUpdate.push(rule);
            }
          } else {
            rulesToAdd.push(rule);
          }
        });
        let that = this;
        if (rulesToUpdate && rulesToUpdate.length > 0) {
          SaveBulkRule(
            this.contractId,
            this.versionId,
            this.editionId,
            this.configuration.id,
            JSON.parse(JSON.stringify(rulesToUpdate)),
            () => {
              that.$emit("updated");
            },
            (error) => {
              this.newRuleErrorObject = error;
            },
          );
        }
        if (rulesToAdd && rulesToAdd.length > 0) {
          let restoredRules = [];
          AddBulkRules(
            this.contractId,
            this.versionId,
            this.editionId,
            this.configuration.id,
            JSON.parse(JSON.stringify(rulesToAdd)),
            (restoredRule) => {
              let restoredId = restoredRule.id;
              let oldId = rulesToAdd[restoredRules.length].id;
              this.updateListItemsWithRestore(oldId, restoredId);
              restoredRules.push(restoredRule);
            },
            () => {
              that.$emit("updated");
            },
            (error) => {
              this.newRuleErrorObject = error;
            },
          );
        }
      }
    },
    updateListItemsWithRestore(oldId, restoredId) {
      this.listItemsHistory.getChangesHistory().map((entry) => {
        entry.value.map((rule) => {
          rule.id = rule.id === oldId ? restoredId : rule.id;
        });
      });
      this.groupedItemsHistory.getChangesHistory().map((entry) => {
        entry.value.map((group) => {
          group.groupEntries.map((rule) => {
            rule.id = rule.id === oldId ? restoredId : rule.id;
          });
        });
      });
    },
    updateGroupsWithRestore(oldId, restoredId) {
      this.groupedItemsHistory.getChangesHistory().map((entry) => {
        entry.value.map((group) => {
          group.id = group.id === oldId ? restoredId : group.id;
          group.groupEntries.map((rule) => {
            rule.ruleGroupId =
              rule.ruleGroupId === oldId ? restoredId : rule.ruleGroupId;
          });
        });
      });
    },
    selectProperty(item, header) {
      let allItems = JSON.parse(JSON.stringify(this.listItems));

      allItems = allItems.filter((filterItem) => {
        return item[header.value] === filterItem[header.value];
      });

      this.selectedUngrouped = JSON.parse(JSON.stringify(allItems));
    },
    switchSelection() {
      let allItems = JSON.parse(
        JSON.stringify(
          this.listItems.filter((item) => {
            return item.ruleGroupId == null;
          }),
        ),
      );
      let selectedUngroupedCopy = JSON.parse(
        JSON.stringify(this.selectedUngrouped),
      );

      for (let index = 0; index < selectedUngroupedCopy.length; index++) {
        let objectIndex = -1;

        for (let i = 0, len = allItems.length; i < len; i++) {
          if (
            JSON.stringify(allItems[i]) ===
            JSON.stringify(selectedUngroupedCopy[index])
          ) {
            objectIndex = i;
            break;
          }
        }

        allItems.splice(objectIndex, 1);
      }

      this.selectedUngrouped = JSON.parse(JSON.stringify(allItems));
    },
    transformDisplayedRuleToDTO(displayObject) {
      let dtoObject = {
        id: displayObject.id,
        order: displayObject.order,
        ruleGroupId: displayObject.ruleGroupId,
        ruleConfigurationId: this.configuration.id,
        entries: [],
      };

      Object.keys(displayObject).forEach((key) => {
        if (
          key == "id" ||
          key == "itemId" ||
          key == "ruleGroupId" ||
          key.includes("criteriaStructureOption")
        ) {
          return;
        }

        let newGroupedEntry = {
          id: 0,
          ruleId: dtoObject.id,
        };

        let idKey = "";
        if (key.includes("criteriaStructureId")) {
          idKey = "criteriaStructureId";
          if (
            Object.keys(displayObject).some((x) =>
              x.includes(`criteriaStructureOption${key.replace(idKey, "")}`),
            )
          ) {
            let mapKey = Number(key.replace(idKey, ""));
            let structureOptions = this.criteriaStructureOptions.get(mapKey);
            if (structureOptions && structureOptions.length > 0) {
              let structureOption = structureOptions.find(
                (option) =>
                  option.value === displayObject[key] &&
                  option.selectionGroupTitle ===
                    displayObject[
                      `criteriaStructureOption${key.replace(idKey, "")}`
                    ],
              );

              newGroupedEntry["criteriaListEntryId"] =
                structureOption.criteriaListEntryId;
            }
          }
        } else if (key.includes("variableId")) {
          idKey = "variableId";
        } else if (key.includes("criteriaGroupId")) {
          idKey = "criteriaGroupId";
        }

        newGroupedEntry[idKey] = key.replace(idKey, "");
        newGroupedEntry.value = displayObject[key];

        dtoObject.entries.push(newGroupedEntry);
      });

      return dtoObject;
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    addNewRule(ruleObject, responseCallBack) {
      this.newRuleErrorObject = null;
      this.isLoading = true;
      AddRule(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        ruleObject,
        (response) => {
          responseCallBack(response);
          this.$emit("updated");
          this.isLoading = false;
        },
        (error) => {
          this.newRuleErrorObject = error;
          this.isLoading = false;
        },
      );
    },
    updateRule(ruleObject, successCallBack, errorCallBack) {
      SaveRule(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        ruleObject,
        () => {
          if (successCallBack) {
            successCallBack();
          }
          this.$emit("updated");
        },
        (error) => {
          this.newRuleErrorObject = error;
          if (errorCallBack) {
            errorCallBack();
          }
        },
      );
    },
    deleteRule(callBack, shouldSaveHistory = true) {
      DeleteRule(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        this.ruleToDelete,
        () => {
          this.hideModal("deleteRule");
          if (callBack) {
            callBack();
          }
          if (shouldSaveHistory) {
            this.handleListItemSaved();
          }
          this.$emit("updated");
        },
        (error) => {
          this.deleteErrorObject = error;
        },
      );
    },
    updateGroupedRule(groupObject) {
      this.newGroupedRuleError = null;

      SaveGroupedRuleConfiguration(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        groupObject.id,
        groupObject,
        () => {
          this.$emit("updated");
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    addNewGroupedRuleEntries(groupObject, groupResponseCallBack) {
      this.isLoading = true;
      this.newGroupedRuleError = null;

      let newGroup = {
        id: groupObject.id,
        ruleConfigurationId: this.configuration.id,
        name: groupObject.name,
        order: groupObject.order,
        groupEntries: [],
      };

      let rules = [];

      groupObject.groupEntries.forEach((groupedRule) => {
        let dtoRule = this.transformDisplayedRuleToDTO(groupedRule);
        dtoRule.oldId = groupedRule.id;
        rules.push(dtoRule);
      });

      AddGroupedRule(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        newGroup,
        (response) => {
          this.ruleGroups.push(response);
          groupResponseCallBack(response);
          let that = this;
          rules.forEach((rule) => {
            ((rule.ruleGroupId = response.id),
              AddRule(
                this.contractId,
                this.versionId,
                this.editionId,
                this.configuration.id,
                rule,
                (ruleResponse) => {
                  let oldId = rule.oldId;
                  let newId = ruleResponse.id;
                  this.updateListItemsWithRestore(oldId, newId);
                  this.rules.push(ruleResponse);
                  that.$emit("updated");
                  this.isLoading = false;
                },
                (error) => {
                  this.newRuleErrorObject = error;
                  this.isLoading = false;
                },
              ));
          });
        },
        (error) => {
          this.newGroupedRuleError = error;
          this.isLoading = false;
        },
      );
    },
    addNewGroupedRule() {
      this.newGroupedRuleError = null;

      let newGroupedRule = {
        id: 0,
        ruleConfigurationId: this.configuration.id,
        name: "Neue Regelgruppierung",
        order: 0,
        groupEntries: [],
      };

      AddGroupedRule(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        newGroupedRule,
        () => {
          this.handleRuleGroupSaved();
          this.$emit("updated");
        },
        (error) => {
          this.newGroupedRuleError = error;
        },
      );
    },
    deleteGroupedRule(callBack) {
      this.deleteGroupedRuleError = null;
      let that = this;

      DeleteGroupedRule(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        this.groupedRuleToDeleteId,
        () => {
          if (callBack) {
            callBack();
          }
          that.$emit("updated");
        },
        (error) => {
          that.deleteGroupedRuleError = error;
        },
      );
    },
    loadAllRules() {
      this.tableHeaders = [];

      this.tableHeaders.push({
        text: "Sortierung",
        sortable: true,
        value: "order",
      });
      this.ruleGroups = JSON.parse(
        JSON.stringify(this.configuration.ruleGroups),
      );

      this.configuration.configEntries.forEach((config) => {
        if (config.criteriaStructureId) {
          this.getAllOptions(
            config.criteriaStructure.id,
            config.criteriaStructure.name,
          );

          this.tableHeaders.push({
            text: JSON.parse(JSON.stringify(config.criteriaStructure.name)),
            sortable: true,
            value: "criteriaStructureId" + config.criteriaStructureId,
          });
        }

        if (config.criteriaGroupId) {
          this.tableHeaders.push({
            text: JSON.parse(JSON.stringify(config.criteriaGroup.name)),
            sortable: true,
            value: "criteriaGroupId" + config.criteriaGroupId,
          });
        }

        if (config.variableId) {
          this.tableHeaders.push({
            text: JSON.parse(JSON.stringify(config.variable.name)),
            sortable: true,
            value: "variableId" + config.variableId,
          });
        }
      });

      this.tableHeaders.push({
        text: "Aktion",
        sortable: false,
      });

      this.GetAllValuesForRule(true);
    },
    GetAllValuesForRule(showLoading) {
      this.isLoading = showLoading;
      this.errorObject = null;

      GetRuleValues(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        (response) => {
          this.listItems = [];

          response.map((item) => {
            let itemObject = {
              itemId: response.id,
              ruleGroupId: item.ruleGroupId,
              order: item.order,
              id: item.id,
            };

            item.entries.map((entry) => {
              if (entry.criteriaStructureId) {
                itemObject["criteriaStructureId" + entry.criteriaStructureId] =
                  entry.value;
                if (
                  this.criteriaStructureOptions.get(
                    entry.criteriaStructureId,
                  ) &&
                  this.criteriaStructureOptions.get(entry.criteriaStructureId)
                    .length > 0
                ) {
                  let structureOptions = this.criteriaStructureOptions.get(
                    entry.criteriaStructureId,
                  );
                  if (structureOptions && structureOptions.length > 0) {
                    structureOptions.forEach((option) => {
                      if (
                        option.value == entry.value &&
                        option.criteriaListEntryId == entry.criteriaListEntryId
                      ) {
                        itemObject[
                          "criteriaStructureOption" + entry.criteriaStructureId
                        ] = option.selectionGroupTitle;
                      }
                    });
                  }
                }
              }

              if (entry.criteriaGroupId) {
                itemObject["criteriaGroupId" + entry.criteriaGroupId] =
                  entry.value;
              }

              if (entry.variableId) {
                itemObject["variableId" + entry.variableId] = entry.value;
              }
            });

            this.listItems.push(itemObject);
          });

          this.listItems.sort((a, b) => {
            return a.order - b.order;
          });

          this.isLoading = false;

          // eslint-disable-next-line
          if (this.initialLoadingDone()) {
            this.updateUndoHistory();
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    getAllOptions(criteriaStructureId, type) {
      this.isLoading = true;
      GetPossibleStructureValues(
        this.contractId,
        this.versionId,
        this.editionId,
        criteriaStructureId,
        [],
        true,
        false,
        (response) => {
          if (response) {
            const criteriaTitels = [];
            response.forEach((criteria) => {
              if (!criteriaTitels.includes(criteria.selectionGroupTitle)) {
                criteriaTitels.push(criteria.selectionGroupTitle);
              }
            });

            if (criteriaTitels.length > 1) {
              let indexOfCriteria = 0;
              this.tableHeaders.forEach((tableHeader, index) => {
                if (tableHeader.text == type) {
                  indexOfCriteria = index;
                }
              });
              this.tableHeaders.splice(indexOfCriteria, 0, {
                text: "Titel Abhängige Liste",
                sortable: true,
                value: "criteriaStructureOption" + criteriaStructureId,
              });
            }

            if (response && response.length > 0) {
              this.criteriaStructureOptions.set(
                criteriaStructureId,
                JSON.parse(JSON.stringify(response)),
              );

              this.GetAllValuesForRule(true);
            }

            this.isLoading = false;
          }
        },
        (error) => {
          console.error(error);
        },
      );
    },
  },
};
</script>

<style>
#confirmDeleteProperty___BV_modal_content_ {
  margin-top: 40px;
}

.configEntryLine .v-text-field {
  padding: 0px;
  margin: 0px;
}

.specialHeight .v-table__overflow {
  max-height: calc(100vh - 300px);
  overflow-y: auto;
}
</style>

<style scoped>
.cursorpointer {
  cursor: pointer;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                                                                                                                       supported by Chrome, Edge, Opera and Firefox */
}

.smallActionButton {
  max-width: 25px;
  min-width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}

.customCol11 {
  -ms-flex: 0 0 11%;
  -webkit-box-flex: 0;
  flex: 0 0 11%;
  max-width: 11%;
}

.customCol80 {
  -ms-flex: 0 0 80%;
  -webkit-box-flex: 0;
  flex: 0 0 80%;
  max-width: 80%;
}

.typeSymbolWrapper {
  border: 1px solid black;
}

.addRuleGroupButton {
  height: 30px;
  width: 30px;
  padding: 2px 6px;
  background-color: #dfdfdf;
  border: 2px solid #dfdfdf;
  cursor: pointer;
}

.addRuleGroupButton:hover {
  background-color: #c7c7c7;
  border: 2px solid #c7c7c7;
}

.addRuleGroupButton.selected {
  background-color: #00dee6;
  border: 2px solid #b7b7b7;
}

.configEntryLine {
  height: 40px;
}
</style>
